import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
const url = qualifyUrl("plugins/org.graylog.plugins.widgetexport/widgetexport");
export const fetchExportData = (exportCallId) => fetch("GET", `${url}/${exportCallId}`).then(
  ({ widget: { widget_type: widgetType, render_type: renderType, ...rest }, data }) => ({
    data,
    widget: {
      widgetType,
      renderType,
      ...rest
    }
  })
);
const useExportData = (exportCallId) => {
  const { data, refetch, isFetching } = useQuery({
    queryKey: ["exported-data", exportCallId],
    queryFn: () => defaultOnError(
      fetchExportData(exportCallId),
      "Fetching data failed with status",
      "Could not retrieve data"
    ),
    placeholderData: keepPreviousData,
    enabled: !!exportCallId
  });
  return {
    data,
    refetch,
    isFetching
  };
};
export default useExportData;
